exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inner {\n  position: absolute;\n  width: 5px;\n  height: 5px;\n  top: 50%;\n  left: 50%;\n  background-color: #00c; }\n\n.mapasMenuItems {\n  position: absolute;\n  padding: 15px; }\n\n.mapasMenuItems > .ui-slidemenu {\n  height: 320px; }\n\n.ui-menuitem > a > span {\n  color: #757575; }\n\n.mapasMenuItemsHeader {\n  padding-bottom: 0px;\n  font-size: 0.8em;\n  text-transform: uppercase;\n  text-align: center; }\n\n.mapasMenuItemsHeader > a > span {\n  color: #757575; }\n\n.mapasMenuItemsFooter {\n  padding-top: 0px; }\n\n.mapasMenuItemsSeparator {\n  padding-left: 10px;\n  padding-right: 10px; }\n\n.menu-segment {\n  opacity: 0.4;\n  fill: #4679bd; }\n\n.menu-segment:hover {\n  opacity: 0.6;\n  fill: #5689cd; }\n\n.menu-icon {\n  pointer-events: none; }\n\n.menu-visibilidad > div {\n  height: 313px; }\n\n.menu-visibilidad > div > div {\n  height: 100% !important; }\n\n.menu-visibilidad > div > div > div {\n  height: 100% !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/adri9/Escritorio/admin-everpath/src/app/views/mapas/mapas.component.scss
// module id = ../../../../../src/app/views/mapas/mapas.component.scss
// module chunks = main